ConfirmDeleteDialog.vue<script setup>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'

const props = defineProps({
  visible: Boolean,
  customerName: {
    type: String,
    default: '',
  },
  workName: {
    type: String,
    default: '',
  },
  employeeName: {
    type: String,
    default: '',
  },
  contactName: {
    type: String,
    default: '',
  },
  facilityName: {
    type: String,
    default: '',
  },
  documentName: {
    type: String,
    default: '',
  },
  contractName: {
    type: String,
    default: '',
  }


})
const emit = defineEmits(['update:visible', 'confirm'])

function onUpdateVisible(value) {
  emit('update:visible', value)
}

function close() {
  emit('update:visible', false)
}
function confirm() {
  emit('confirm')
  close()
}
</script>


<template>
  <Dialog
      :visible="visible"
      @update:visible="(v) => $emit('update:visible', v)"
      header="Подтвердите"
      :closable="false"
      modal
  >
    <div class="mb-4 text-center text-md">
      <span v-if="customerName">Вы хотите удалить <b>«{{ customerName }}»</b>?</span>
      <span v-else-if="workName">Вы хотите удалить <b>«{{ workName }}»</b>?</span>
      <span v-else-if="employeeName">Вы хотите удалить <b>«{{ employeeName }}»</b>?</span>
      <span v-else-if="contactName">Вы хотите удалить <b>«{{ contactName }}»</b>?</span>
      <span v-else-if="facilityName">Вы хотите удалить <b>«{{ facilityName }}»</b>?</span>
      <span v-else-if="documentName">Вы хотите удалить документ <b>«{{ documentName }}»</b>?</span>
      <span v-else-if="contractName">Поместить в архив договор <b>«{{ contractName }}»</b>?</span>
      <span v-else>Удалить это?</span>
    </div>
    <template class="flex justify-center gap-2">
      <Button label="Удалить" severity="danger" @click="confirm" security="danger" rounded size="small"/>
      <Button label="Отмена" @click="$emit('update:visible', false)" severity="secondary" rounded size="small"/>

    </template>
  </Dialog>

</template>


<style scoped>

</style>